import { render, staticRenderFns } from "./points.vue?vue&type=template&id=ff4f7e20&scoped=true"
import script from "./points.vue?vue&type=script&lang=ts&setup=true"
export * from "./points.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./points.vue?vue&type=style&index=0&id=ff4f7e20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4f7e20",
  null
  
)

export default component.exports